import { MarkedDownContent } from "@thrivetribe/mvf.ui.atoms.marked-down-content";
import React from "react";
import "./ArticleContent.scss";

interface ArticleContentType {
  imgUrl: string;
  imgAlt: string;
  introduction: string;
  body: string;
}

export const ArticleContent: React.FC<ArticleContentType> = ({
  imgUrl,
  imgAlt,
  introduction,
  body,
}: ArticleContentType) => {
  return (
    <div className="article">
      <img className="article__image" src={imgUrl} alt={imgAlt} />
      <p className="article__introduction">{introduction}</p>
      <div className="article__body">
        <MarkedDownContent content={body} />
      </div>
    </div>
  );
};
